import { Link } from 'react-router-dom'
import { BUSINESS } from '../../constants/business'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="bg-[#111111] text-brand-stone" aria-label="Site footer">
      <div className="h-0.5 bg-brand-brown" />

      <div className="container-custom py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Brand */}
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src="/photos/robbakersgarage-logo.png" alt="Rob Baker's Garage" className="w-14 h-14 object-contain rounded-full" />
            <div>
              <span className="font-heading text-white text-sm font-bold tracking-wide block">ROB BAKER&apos;S GARAGE</span>
              <span className="text-brand-stone/40 text-[10px] uppercase tracking-widest block mt-0.5">Est. 1972 · Millbrae, CA</span>
            </div>
          </div>
          <p className="text-sm text-brand-stone/60 leading-relaxed mb-4">
            {BUSINESS.tagline}. Honest service, fair prices, and over 50 years of community trust.
          </p>
          <div className="flex items-center gap-3">
            <a href={BUSINESS.facebookUrl} target="_blank" rel="noopener noreferrer"
              className="w-9 h-9 rounded border border-white/10 flex items-center justify-center text-brand-stone/50 hover:text-white hover:border-white/30 transition-colors" aria-label="Facebook">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
            </a>
            <a href={BUSINESS.instagramUrl} target="_blank" rel="noopener noreferrer"
              className="w-9 h-9 rounded border border-white/10 flex items-center justify-center text-brand-stone/50 hover:text-white hover:border-white/30 transition-colors" aria-label="Instagram">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-heading text-white text-xs uppercase tracking-widest mb-4 pb-2 border-b border-white/10">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            {[['/', 'Home'], ['/about', 'About Us'], ['/reviews', 'Reviews'], ['/blog', 'Blog']].map(([to, label]) => (
              <li key={to}>
                <Link to={to} className="text-brand-stone/60 hover:text-white transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="font-heading text-white text-xs uppercase tracking-widest mb-4 pb-2 border-b border-white/10">Services</h3>
          <ul className="space-y-2 text-sm text-brand-stone/60">
            {['Auto Diagnostics', 'Brake Repairs', 'Tune Ups', 'AC & Heat Repairs', 'Oil Changes', 'Vehicle Inspection'].map(s => <li key={s}>{s}</li>)}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-heading text-white text-xs uppercase tracking-widest mb-4 pb-2 border-b border-white/10">Contact</h3>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={BUSINESS.googleMapsUrl} target="_blank" rel="noopener noreferrer"
                className="text-brand-stone/60 hover:text-white transition-colors flex items-start gap-2">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mt-0.5 flex-shrink-0" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                <span>{BUSINESS.address.full}</span>
              </a>
            </li>
            <li>
              <a href={`tel:${BUSINESS.phone}`} className="text-brand-stone/60 hover:text-white transition-colors flex items-center gap-2">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012.18 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.15a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                </svg>
                {BUSINESS.phoneFormatted}
              </a>
            </li>
            <li className="flex items-start gap-2 text-brand-stone/60">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mt-0.5 flex-shrink-0" aria-hidden="true">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
              <span>Mon–Fri: {BUSINESS.hours.weekdays}<br/>Sat–Sun: Closed</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-custom py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-brand-stone/30">
          <p>&copy; {year} {BUSINESS.name}. All rights reserved.</p>
          <p>1009 El Camino Real, Millbrae, CA 94030</p>
        </div>
      </div>
    </footer>
  )
}
